module.exports = __webpack_public_path__ + "img/pin_green.261099e8.svg";